import { render, staticRenderFns } from "./ModalChangePassword.vue?vue&type=template&id=7a6a824d&scoped=true"
import script from "./ModalChangePassword.vue?vue&type=script&lang=js"
export * from "./ModalChangePassword.vue?vue&type=script&lang=js"
import style0 from "./ModalChangePassword.vue?vue&type=style&index=0&id=7a6a824d&prod&lang=scss&scoped=true"
import style1 from "./ModalChangePassword.vue?vue&type=style&index=1&id=7a6a824d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6a824d",
  null
  
)

export default component.exports